/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { SelectInput } from "components/Select";
import { useFilterActions } from "../../../ducks/filter/hooks/actions";
import { useFilterState } from "../../../ducks/filter/hooks/filterState";
import {
  useGetRegionalResponsibleQuery,
  useGetRegisterCodeOptionsQuery,
  useGetStoresOptionsQuery,
  useGetStoresResponsiblesOptionsQuery,
} from "../../../../../../services/store/select-options";
import { RoleEnum } from "../../../../../../enum/role";
import { ISelectFilter } from "src/@types/select-filter";
import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";

export default function SelectFilters() {
  const { updateFilter } = useFilterActions();
  const filterState = useFilterState();
  const { filters } = filterState || { filters: {} };

  const { data: storeOptions } = useGetStoresOptionsQuery();
  const { data: responsibleOptions } = useGetStoresResponsiblesOptionsQuery({
    role: RoleEnum.ANALISTA,
  });
  const { data: regionOptions } = useGetRegionalResponsibleQuery();
  const { data: registerCodeOptions } = useGetRegisterCodeOptionsQuery()

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const findOption = (options: any[] | undefined, value: any) =>
    options?.find((opt: any) => String(opt.value) === String(value)) ?? null;

  const selectedStore = useMemo(
    () => findOption(storeOptions, filters.code),
    [storeOptions, filters.code]
  );
  const selectedRegion = useMemo(
    () => findOption(regionOptions, filters.regional_id),
    [regionOptions, filters.regional_id]
  );
  const selectedResponsible = useMemo(
    () => findOption(responsibleOptions, filters.responsible),
    [responsibleOptions, filters.responsible]
  );
  const selectedRegisterCode = useMemo(
    () => findOption(registerCodeOptions as unknown as any[], filters.register_code),
    [registerCodeOptions, filters.register_code]
  );

  const handleSelectStoreChange = (
    option: any | { value: string; label: string }
  ) => {
    updateFilter({ key: "code", value: option?.value });
    updateFilter({ key: "meta", value: { page: 1 } });
  };

  const handleSelectResponsibleChange = (
    option: any | { value: string; label: string }
  ) => {
    updateFilter({ key: "responsible", value: option?.value });
    updateFilter({ key: "meta", value: { page: 1 } });
  };

  const handleSelectRegionResponsibleChange = (
    option: any | { value: string; label: string }
  ) => {
    updateFilter({ key: "regional_id", value: option?.value });
    updateFilter({ key: "meta", value: { page: 1 } });
  };

  const handleSelectRegisterCodeChange = (
    option: any | { value: string; label: string }
  ) => {
    updateFilter({ key: "register_code", value: option?.value });
    updateFilter({ key: "meta", value: { page: 1 } });
  };

  useEffect(() => {
    const codeParam = searchParams.get("code");
    if (codeParam) updateFilter({ key: "code", value: codeParam });
  }, [searchParams, updateFilter]);

  let filtersData: any = [
    {
      options: storeOptions,
      placeholder: "Selecionar loja",
      onChange: handleSelectStoreChange,
      className: "select-filter",
      classNamePrefix: "an-simple-select",
      value: selectedStore,
    },
    {
      options: regionOptions,
      placeholder: "Selecionar regional",
      onChange: handleSelectRegionResponsibleChange,
      className: "select-filter",
      classNamePrefix: "an-simple-select",
      value: selectedRegion,
    },
    {
      options: responsibleOptions,
      placeholder: "Selecionar responsável",
      onChange: handleSelectResponsibleChange,
      className: "select-filter",
      classNamePrefix: "an-simple-select",
      value: selectedResponsible,
    },
    {
      options: registerCodeOptions,
      placeholder: "Selecionar Caixa",
      onChange: handleSelectRegisterCodeChange,
      className: "select-filter",
      classNamePrefix: "an-simple-select",
      value: selectedRegisterCode,
    },
  ];
  return (
    <div className="flex gap-2 flex-wrap">
      {filtersData.map((filter: ISelectFilter) => (
        <SelectInput
          key={filter?.placeholder}
          options={filter?.options}
          placeholder={filter?.placeholder}
          onChange={filter?.onChange}
          className={filter?.className}
          classNamePrefix={filter?.classNamePrefix}
          value={filter?.value}
          isClearable
        />
      ))}
    </div>
  );
}
